import { render, staticRenderFns } from "./ChatModelsForm.vue?vue&type=template&id=010cfbbc&"
import script from "./ChatModelsForm.vue?vue&type=script&lang=js&"
export * from "./ChatModelsForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatModelsForm.vue?vue&type=style&index=0&id=010cfbbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports